import { createApp } from 'vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import axios from 'axios';

import vco from "v-click-outside"
import VueApexCharts from 'vue-apexcharts'
import VueSweetalert2 from 'vue-sweetalert2';
import VueSlideBar from 'vue-slide-bar'
import i18n from './i18n'
import store from '@/state/store'

import App from './App.vue'
// As a plugin
import VueMask from 'v-mask'

import Lightbox from 'vue-easy-lightbox'

import { initFirebaseBackend } from './helpers/firebase/authUtils';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
}

//import { configureFakeBackend } from './helpers/fakebackend/fake-backend';
//configureFakeBackend();

import '@/assets/scss/app.scss'

//AJOUTER UNE EXCEPTION ICI POUR LA REQUETE DE LOGIN
axios.interceptors.request.use(config => {
  if (config.url.includes('gabriellavico.coach')) {
    var user = localStorage.getItem('user2');
    var token = JSON.parse(user).token;
    config.headers["Authorization"] = 'Bearer ' + token;
  }
  return config;
});

// TEMP diagnostic — logs the REAL reason behind the "cancelled" runtime
// rejection so we can pinpoint its source. Remove once identified.
window.addEventListener('unhandledrejection', (event) => {
  const r = event.reason || {}
  // eslint-disable-next-line no-console
  console.error('[DIAG unhandledrejection]', {
    message: r.message,
    name: r.name,
    code: r.code,
    type: r.type,
    stack: r.stack,
    reason: r,
  })
})

const app = createApp(App)

app.mixin({
  computed: {
    isAdmin() {
      const val = localStorage.getItem('isAdmin');
      if (!val || val === 'undefined' || val === 'null') return false;
      try { return JSON.parse(val); } catch(e) { return false; }
    }
  }
})

app.component('VueSlideBar', VueSlideBar)
app.use(BootstrapVue)
app.use(vco)
app.component('apexchart', VueApexCharts)
app.use(VueSweetalert2)
app.use(require('vue-moment'))
app.use(require("vue-chartist"))
app.use(VueMask)
app.use(Lightbox)

app.use(router)
app.use(store)
app.use(i18n)

app.mount('#app')
